// This code is already present on skeleton V3 in marmeto-base.js with example section. This has been added for the implementation of faqs component.
if (!customElements.get('accordion-element')) {
    class Accordion extends HTMLElement {
      constructor() {
        super();
      }
  
      connectedCallback() {
        this.accordionElement = this;
        this.accordionTitle = this.querySelector('accordion-title');
        this.accordionDescription = this.querySelector('accordion-description');
        this.accordionContainer = this.closest('accordion-container');
        
        this.accordionTitle.addEventListener('click', () => this.toggleAccordion());
      }
  
      toggleAccordion() {
        const isActive = this.accordionElement.classList.contains('active');
  
        // Close any other active accordion within the same accordion container
        if (!isActive) {
          this.closeOtherAccordions();
        }
  
        if (isActive) {
          this.collapseAccordion();
        } else {
          this.expandAccordion();
        }
      }
  
      closeOtherAccordions() {
        const otherAccordions = this.accordionContainer.querySelectorAll('accordion-element.active');
  
        otherAccordions.forEach((accordion) => {
          if (accordion !== this.accordionElement) {
            accordion.classList.remove('active');
            const description = accordion.querySelector('accordion-description');
            const heightInRem = description.scrollHeight / 10; // Convert px to rem
            description.style.height = `${heightInRem}rem`;
            requestAnimationFrame(() => {
              description.style.height = '0rem';
            });
          }
        });
      }
  
      expandAccordion() {
        this.accordionElement.classList.add('active');
        const fullHeightInRem = this.accordionDescription.scrollHeight / 10; // Convert px to rem
        this.accordionDescription.style.height = `0rem`;
        requestAnimationFrame(() => {
          this.accordionDescription.style.height = `${fullHeightInRem}rem`;
        });
      }
  
      collapseAccordion() {
        this.accordionElement.classList.remove('active');
        const heightInRem = this.accordionDescription.scrollHeight / 10; // Convert px to rem
        this.accordionDescription.style.height = `${heightInRem}rem`;
        requestAnimationFrame(() => {
          this.accordionDescription.style.height = '0rem';
        });
      }
    }
  
    customElements.define('accordion-element', Accordion);
  }